import { useAuth } from 'context/auth';
import useSWR, { SWRHook } from 'swr';

// @ts-expect-error FIXME: TS7006 - strict mode migration
export const useSWRWhenAuthed: SWRHook = (key, ...args) => {
  const { isLoggedIn } = useAuth();
  const [fetcher, config] = args;
  return useSWR(isLoggedIn ? key : null, fetcher, config);
};
